export default "<p>welcome-page works!</p>\n"